import { render, staticRenderFns } from "./MSTeamsAuth.vue?vue&type=template&id=70ad41ef"
import script from "./MSTeamsAuth.vue?vue&type=script&lang=js"
export * from "./MSTeamsAuth.vue?vue&type=script&lang=js"
import style0 from "./MSTeamsAuth.vue?vue&type=style&index=0&id=70ad41ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports